export default __webpack_public_path__ + "static/media/available_hover_connected_selected.74cb64b3.svg";